import { PageHeader } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { AnnouncementsBody } from "../../features/platform/account.js";
import { useDocumentTitle } from "../../lib/hooks.js";

export const Route = createFileRoute("/_app/duyurular")({ component: AnnouncementsPage });

/** Duyuru merkezi (Prompt 24): platformun sürüm notları, duyuruları ve planlı bakımları; okundu bilgisi kullanıcı başınadır. */
function AnnouncementsPage(): ReactElement {
  const { t } = useTranslation();
  useDocumentTitle(t("menu.announcements"));
  return (
    <>
      <PageHeader
        title={t("menu.announcements")}
        description={t("account.announcements.description")}
        breadcrumb={[{ label: t("menu.groups.main") }, { label: t("menu.announcements") }]}
      />
      <AnnouncementsBody />
    </>
  );
}
